import React from 'react';
import { Table, Td, TdImp, Th, Tr } from '../CyberSecurityComponents/css';
import { FieldSchema } from '../CyberSecurityComponents/fieldSchema';

export const TableCS = ({fieldData}) => {

  return (
    <Table style={{
        marginTop: '10px'
      }}>
      <Tr>
        <Td> </Td>
        <Td>Quantity</Td>
        <Td>Total Price</Td>
      </Tr>
      {FieldSchema.map((rowItem, rowIndex) => {
        return (
          <Tr>
            <TdImp>
              {rowItem.text}
              <span
                style={{
                  display: 'block',
                  fontWeight: 'lighter',
                  fontStyle: 'italic',
                  fontSize: '13px'
                }}
              >
                {rowItem.note ? rowItem.note : ''}
              </span>
            </TdImp>
            <Th>
              <input
                id={rowItem.name[0]}
                name={rowItem.name[0]}
                type="Number"
                onWheel={e => e.target.blur()}
                value={
                  fieldData[rowItem.name[0]]
                    ? fieldData[rowItem.name[0]][rowItem.name[0]]
                    : null
                }
                placeholder={rowItem.placeholder}
                className="frg-input-field color-light"
                style={{ width: '100%' }}
                disabled
              />
            </Th>
            <Th>
              <input
                id={rowItem.name[1]}
                name={rowItem.name[1]}
                type="string"
                onWheel={e => e.target.blur()}
                value={
                  fieldData[rowItem.name[0]]
                    ? `${parseFloat(fieldData[rowItem.name[0]][rowItem.name[1]]).toFixed(2)} $`
                    : `${(0).toFixed(2)} $`
                }
                className="frg-input-field color-light"
                style={{ width: '100%' }}
                disabled
              />
            </Th>
          </Tr>
        );
      })}
    </Table>
  );
};
